import { IGrade } from '../models/grades-model';
import GradeMapper from '../mappings/grades-mapper';
import { Config } from '../models/config-viewmodel';

class GradeService {
    private gradeMapper = new GradeMapper();

    constructor() {}

    public getRecentGrades = (config: Config, HttpService: any) => {
        return this.getGrades(this.getRecentGradeQuery(config), HttpService);
    }

    private getGrades = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(url).then((result: IGrade[]) => {
                resolve(result.map((grade: IGrade) => this.gradeMapper.mapGrade(grade)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getRecentGradeQuery = (config: Config): string => {
        return `/api/students/${config.language}/recent-appraisals`;
    }
}

export default new GradeService();
